import { API_AUTH } from "./common";

const CustomerApi = {
  list: ({
    dateFrom,
    dateTo,
    code,
    customerName,
    address,
    noteTaiSan,
    status,
    debt,
    userName,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `quanlychovay/danh-sach-cam-do?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  detail: (params) =>
    API_AUTH.get(
      `quanlykhachhang/khach-hang-chi-tiet`,params
    ),
  lichSuGiaoDich: (params) =>
    API_AUTH.get(
      `quanlykhachhang/khach-hang-lich-su-giao-dich`,params
    ),
  Autocomplete: ({ tuKhoa }) =>
    API_AUTH.get(
      `quanlykhachhang/khach-hang-autocomplete?tuKhoa=${tuKhoa}`,
      {}
    ),

  kiemTraTrungCCCD: ({ cmt, customerId }) =>
    API_AUTH.get(
      `quanlykhachhang/kiem-tra-trung-cccd?cmt=${encodeURIComponent(cmt)}&customerId=${customerId || 0}`,
      {}
    ),

  AutocompleteChuNo: ({ tuKhoa }) =>
    API_AUTH.get(
      `quanlykhachhang/chu-no-autocomplete?tuKhoa=${tuKhoa}`,
      {}
    ),

  checkEditCustomer: (customerId) =>
    API_AUTH.post(
      `quan-ly-cho-vay/kiem-tra-sua-khach-hang?customerId=${customerId}`,
      {}
    ),
    checkEditCustomerV2: (customerId) =>
    API_AUTH.post(
      `quan-ly-cho-vay/kiem-tra-sua-khach-hang?customerId=${customerId}`,
      {}
    ),
};

export default CustomerApi;
